export default "__VITE_ASSET__2dohMbdZ__"